import { combineReducers } from 'redux';
import { createReducer } from 'redux-starter-kit';
export var todosReducer = createReducer({}, {
    addTodo: function (state, action) {
        state[action.id] = { label: action.label, completed: false };
    },
    remove: function (state, action) {
        delete state[action.id];
    },
    clear: function (state, action) {
        Object.keys(state).forEach(function (key) {
            if (state[key].completed) {
                delete state[key];
            }
        });
    },
    complete: function (state, action) {
        state[action.id].completed = !state[action.id].completed;
    },
    edit: function (state, action) {
        state[action.id].label = action.label;
    }
});
export var filterReducer = createReducer('all', {
    setFilter: function (state, action) {
        return action.filter;
    }
});
export var reducer = combineReducers({
    todos: todosReducer,
    filter: filterReducer
});
